<template>
	<div class="fuel">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
            <div class="col-md-12 mb-2">
				<h4>OTHER INCOME</h4>
			</div>

			<div class="col-md-12">
				<div class="row">

					<div class="col-md-6 mb-4">
						<el-card shadow="hover">
                            <div slot="header" class="px-1">
                                <h6 class="text-center m-0">Other Income By Month</h6>
                            </div>

                            <div>
                                <BarChart :data="barchartdata.bymonth" :width="500" :height="350"/>
                                <Loader v-if="loading.chart" />
                            </div>
                        </el-card>
					</div>

                    <div class="col-md-4 mb-4">
						<el-card shadow="hover">
                            <div slot="header" class="px-1">
                                <h6 class="text-center m-0">Other Income By Principal</h6>
                            </div>

                            <div class="">
                                <PieChart class="" :data="piechartdata.byprincipal" :url="''" style="width:100%;" :showlegend="false"/>
                                <Loader v-if="loading.chart" />
                            </div>
                        </el-card>
					</div>

                    <div class="col-md-4 mb-4">
						<el-card shadow="hover">
                            <div slot="header" class="px-1">
                                <h6 class="text-center m-0">Trading Term {{ year }}</h6>
                            </div>

                            <div>
                                <PieChart class="" :data="piechartdata.tradingterm" :url="''" style="width:100%;" :showlegend="false"/>
                                <Loader v-if="loading.chart" />
                            </div>
                        </el-card>
					</div>

                    <div class="col-md-6 mb-4">
						<el-card shadow="hover">
                            <div slot="header" class="px-1">
                                <h6 class="text-center m-0">Target Sales Store & Cafe RKAP {{ year }} Percentage OI</h6>
                            </div>

                            <div>
                                <BarChart :data="barchartdata.revenue" :width="500" :height="350"/>
                                <Loader v-if="loading.chart" />
                            </div>
                        </el-card>
					</div>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import { Rainbow, FuelColor, AppColors, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default{
	extends: Fuel,
	components:{
		PieChart,         
        BarChart,
        Loader,
	},

	data() {
		return {
			isChildRoute: false,
            chartcolors: ['#F56C6C','#67C23A','#3C61FF','#F14C5D', '#E6A23C','#8C5CFF'],
            reportdata: {
                data: [],
            },
            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,
            area: '',
            loading: {
                chart: false,
            },

            barchartdata: {
                bymonth: [],
                revenue: [],
            },
            piechartdata: {
                byprincipal: [],
                tradingterm: [],
            }
            //pieChartDataPayment : [],
		}
	},

	watch : {
		$route(to, from) {
            this.hideNonChildren();
        }
	},

	computed:{
		
	},

    mounted() {
		this.hideNonChildren();
        this.getData();
    },
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/bright/other-income';
        },
        async getData() {
            
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/brightsummary/otherincome?'

            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month
			this.urlRequestParams += '&area='+this.area
			
            this.loading.chart = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;

                    this.piechartdata = {
                        byprincipal: this.setPieChart(this.reportdata?.data?.by_principal ?? []),
                        tradingterm: this.setPieChart(this.reportdata?.data?.trading_term ?? []),
                    };

                    this.barchartdata = {
                        bymonth: this.setBarchart(this.reportdata?.data?.by_month ?? []),
                        revenue: this.setBarchart(this.reportdata?.data?.revenue ?? []),
                    };

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
				})
        },
        setBarchart(data) {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Label'
            let value = 'Value'
            let legend = 'Legend'
            return this.processBarChart(data, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
        },
        setPieChart(data) {
            let item = data;
            let warna = [];
            let defaultcolors = AppColors; //this.chartcolors; //colors ? AppColors : this.chartcolors;
            //console.log('JSON: ' + AppColors);
            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = defaultcolors[idx] //Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('result: ' + JSON.stringify(result))          
            //console.log('groupedArray: ' + JSON.stringify(groupedArray));
            //this.piechartdata = result

            return result 
        },
	}
}
</script>